<template>
  <v-container fluid class="pa-0">
    <v-tabs v-model="tab" centered icons-and-text>
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1" class="text-none font-weight-bold">
        Leave Request
        <v-icon>mdi-calendar-heart</v-icon>
      </v-tab>
      <v-tab href="#tab-2" class="text-none font-weight-bold">
        Overtime Request
        <v-icon>mdi-timer-outline</v-icon>
      </v-tab>
      <v-tab href="#tab-3" class="text-none font-weight-bold">
        Work From Home
        <v-icon>mdi-home-account</v-icon>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <v-card flat>
          <LeaveRequest mode="leave" />
        </v-card>
      </v-tab-item>

      <v-tab-item value="tab-2">
        <v-card flat>
          <OvertimeComponent />
        </v-card>
      </v-tab-item>

      <v-tab-item value="tab-3">
        <v-card flat>
          <LeaveRequest mode="wfh" />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
/**components */
import LeaveRequest from "./LeaveRequest.vue";
import OvertimeComponent from "./OvertimeComponent.vue";

export default {
  components: {
    LeaveRequest,
    OvertimeComponent,
  },
  data() {
    return {
      tab: null,
    };
  },
};
</script>
